Wee.fn.make('csrf', {
	_construct: function() {
		var scope = this;

		$.chain('csrf', function(options) {
			if (typeof options === 'undefined') {
				options = {};
			}

			options.selector = this;

			scope.init(options);

			return this;
		});
	},

	/**
	 * Generate CSRF token and prepend to form
	 *
	 * @param {object} options
	 * @param {object|string} [options.selector=ref:csrfForm]
	 * @param {string} [options.endpoint=/ajax/csrf]
	 */
	init: function(options) {
		var priv = this.$private,
			conf = $.extend({
				selector: 'ref:csrfForm',
				endpoint: '/ajax/csrf'
			}, options),
			selector = conf.selector,
			$form = typeof selector != 'object' ? $(selector) : selector;

		if ($.get('csrf')) {
			priv.insertInput($form);
		} else {
			$.fetch.request({
				url: conf.endpoint,
				json: true,
				success: function(response) {
					$.set('csrf', response);

					priv.insertInput($form);
				}
			});
		}
	}
}, {
	/**
	 * Insert CSRF input into form
	 *
	 * @param {object} $form
	 */
	insertInput: function($form) {
		var csrf = $.get('csrf'),
			$existingToken = $form.find('input[name="' + csrf.name + '"]');

		if ($existingToken.length) {
			// If a token already exists, strip it out
			$existingToken.remove();
		}

		$form.prepend(
			$.view.render(
				'<input type="hidden" name="{{ name }}" value="{{ value }}">',
				csrf
			)
		);
	}
});